// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__31JB7","modalForm":"UpgradeEpcsModal_modalForm__1HlUA","modalFooter":"UpgradeEpcsModal_modalFooter__3n6Ch"};